'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  height: ',
    ';\n  border: 0;\n  border-radius: ',
    ';\n  background-color: ',
    ';\n'
  ],
  [
    '\n  height: ',
    ';\n  border: 0;\n  border-radius: ',
    ';\n  background-color: ',
    ';\n'
  ]
)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Divider = _Box2.default.withComponent('hr').extend(
  _templateObject,
  function(props) {
    return props.height
  },
  function(props) {
    return props.theme.pill
  },
  function(props) {
    return (0, _theme.cx)(
      props.color || props.borderColor || props.bg || 'smoke'
    )
  }
)

Divider.displayName = 'Divider'

Divider.defaultProps = {
  height: '3px',
  mx: 0
}

Divider.propTypes = {
  height: _propTypes2.default.string,
  color: _propTypes2.default.string
}

exports.default = Divider



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Divider.js
// module id = 511
// module chunks = 168707334958949